import React, { useEffect, useState } from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavCommunications,
} from "../../../../components/AdminComponents/MenuItems";
import {
  Pagination,
  Spin,
  Switch,
  Table,
  Tag,
  Popconfirm,
  message,
} from "antd";
import {
  capitalizeWords,
  getFullApplicationName,
  ModuleColor,
  remainingViewportHeight,
  UserTypeColor,
} from "../../../../components/icons/ApplicationColor";
import {
  CheckOutlined,
  CloseOutlined,
  DeleteTwoTone,
  SwapOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import EditableImage from "../../../../components/icons/EditIcon";
import { useSelector } from "react-redux";
import { getUpdateStatus } from "../../../../components/AdminComponents/ViewUpdateIndex";
import Axios from "../../../../api/Axios";
import FilterTemplates from "../../../../components/AdminComponents/Modals/FilterTemplates";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";

const TemplateListing = () => {
  const history = useNavigate();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [applications, setApplications] = useState([]);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const roles = ["admin", "trainer", "attendee"];
  const [selectedRoles, setSelectedRoles] = useState([]);
  const types = ["ENGAGEMENT", "EVENT"];
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [itemsLength, setItemsLength] = useState();
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus(userInfo, 3, 0);
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    active: true,
    url: `/mailtemplatelist/${userInfo?.data?.organization?.id}/`,
    search: "",
    filters: "",
    filter_flag: false,
  });
  const { pageSize, currentPage, url, search, active, filters, filter_flag } =
    filterData;
  const LoadContacts = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}${filters}&status=${
          active ? "True" : "False"
        }`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}${filters}&status=${
        active ? "True" : "False"
      }`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        //console.log(res.data.results);
        setItemsLength(res.data.count);
        setData(res.data.results);
        setLoading(false);

        //console.log(data);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setLoading(false);
        }
        //console.log(err);
      }
    }
  };
  const LoadUser = async () => {
    try {
      const res = await Axios.get("/applicationlist/?status=True");
      setApplications(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    LoadUser();
  }, []);
  useEffect(() => {
    LoadContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const handleCancel = () => {
    setVisible(false);
  };

  const showModal = () => {
    setVisible(true);
  };

  const ResetFields = async () => {
    console.log("reset from modal");

    setSelectedApplications([]);
    setSelectedRoles([]);
    setSelectedTypes([]);
    handleCancel();
    setFilterData(() => ({
      pageSize: 15,
      currentPage: 1,
      active: true,
      url: `/mailtemplatelist/${userInfo?.data?.organization?.id}/`,
      search: "",
      filters: "",
      filter_flag: false,
    }));
  };
  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  const handleSwitchChange = (checked) => {
    setFilterData((prevData) => ({
      ...prevData,
      active: checked,
      currentPage: 1,
    }));
  };
  const renderStatus = (text, record) => {
    if (active) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
  };
  const handleRowClick = (record) => {
    if (updateAuth) {
      history(
        `/ca-admin/organization/communications/templates/edit-template/${record}`
      );
    } else {
      //console.log("not allowed");
    }
  };
  const InactiveLocation = (props, message) => {
    messageApi.open({
      type: props,
      content: message,
      duration: 5,
    });
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleDeleteAndSwap = async (record, type) => {
    //console.log("coming here", record.id);
    const data = {
      status: type,
    };
    try {
      await Axios.put(`/mailtemplate/${record?.id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      setFilterData((prevData) => ({
        ...prevData,
        search: "",
      }));
      LoadContacts();
      InactiveLocation("success", "Template has been Archived");
    } catch (err) {
      //console.log(err, "error");
      InactiveLocation("error", err?.response?.data?.detail);
    }
  };
  const columns = [
    {
      title: capitalizeWords("TYPE"),
      dataIndex: "type",
      key: "type",
      width: 180,
    },

    {
      title: capitalizeWords("TITLE"),
      dataIndex: "title",
      key: "title",
      width: 300,
    },
    {
      title: capitalizeWords("SUBJECT"),
      dataIndex: "subject",
      key: "subject",
      width: 300,
    },
    {
      title: capitalizeWords("MODULE ACCESS"),
      dataIndex: "application",
      key: "application",
      width: 200,
      render: (application) => (
        <>
          <Tag
            color={ModuleColor(getFullApplicationName(application))}
            title={application}
            style={{ fontWeight: "500", margin: "3px" }}
          >
            {getFullApplicationName(application).toUpperCase()}
          </Tag>
        </>
      ),
    },
    {
      title: capitalizeWords("USER ACCESS"),
      dataIndex: "user_type",
      key: "user_type",
      width: 300,
      render: (userTypes) => (
        <>
          {userTypes?.map((type, index) => (
            <Tag
              color={UserTypeColor(type)}
              key={index}
              title={type}
              style={{ fontWeight: "500", margin: "3px" }}
            >
              {type.toUpperCase()}
            </Tag>
          ))}
        </>
      ),
    },

    {
      title: capitalizeWords("STATUS"),
      dataIndex: "active",
      key: "active",
      render: renderStatus,
      width: 100,
      align: "center",
    },
    ...(updateAuth
      ? [
          {
            title: capitalizeWords("ACTIONS"),
            dataIndex: "actions",
            key: "actions",
            fixed: "right",
            align: "center",
            width: 100,
            onCell: (record) => {
              return {
                onClick: (event) => {
                  event.stopPropagation();
                },
              };
            },

            render: (text, record) => {
              return active ? (
                <>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <EditableImage
                      handleRowClick={handleRowClick}
                      recordId={record.id}
                    />
                    <Popconfirm
                      title="Archive Template"
                      description=" "
                      onConfirm={() => handleDeleteAndSwap(record, false)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                      placement="left"
                    >
                      <DeleteTwoTone
                        style={{
                          cursor: "pointer",
                          fontSize: "1.8rem",
                          marginLeft: "0.9rem",
                        }}
                        // onClick={() => {
                        //   handleDelete(record);
                        // }}
                        title="delete"
                        twoToneColor="#eb2f96"
                      />
                    </Popconfirm>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Popconfirm
                      title="Unarchive Temmplate"
                      description=" "
                      onConfirm={() => handleDeleteAndSwap(record, true)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                      placement="left"
                    >
                      <SwapOutlined
                        style={{
                          cursor: "pointer",
                          fontSize: "1.8rem",
                          marginLeft: "0.9rem",
                        }}
                        title="unarchive"
                      />
                    </Popconfirm>
                  </div>
                </>
              );
            },
          },
        ]
      : []),
  ];
  const handleApply = async () => {
    console.log(selectedApplications);

    let filter_url = "";
    if (selectedRoles.length > 0) {
      filter_url += `&user_type=${selectedRoles.join(",")}`;
    }
    if (selectedApplications.length > 0) {
      filter_url += `&application=${selectedApplications.join(",")}`;
    }
    if (selectedTypes.length > 0) {
      filter_url += `&type=${selectedTypes.join(",")}`;
    }
    console.log(filter_url, "filter_url");

    setFilterData((prevData) => ({
      ...prevData,
      filter_flag: true,
      filters: filter_url,
      currentPage: 1,
    }));

    console.log(url);
    setVisible(false);
  };

  return (
    <CaSideNav props={CaAdminMenu}>
      {contextHolder}
      <SecondaryNav2 menuItems={SecondaryNavCommunications} />
      <CommonTopDetails
        title={active ? "Mail Templates" : "Inactive Templates"}
        titleSuffix={`${itemsLength || 0} template(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={updateAuth}
        filterAction={true}
        marginPass="15px"
        addButtonProps={{
          modalType: "Redirect",
          redirctlink:
            "/ca-admin/organization/communications/templates/add-template/",
        }}
        filterUrl={filter_flag}
        filterButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
        resetButtonProps={{
          modalProps: ResetFields,
        }}
        customContent={
          <Switch
            style={{
              backgroundColor: active ? "#50C878" : "#FF0000",
              minWidth: "90px",
            }}
            checked={active}
            onChange={handleSwitchChange}
            disabled={loading}
            checkedChildren="ACTIVE"
            unCheckedChildren="INACTIVE"
          />
        }
      />

      <div>
        <Spin spinning={loading}>
          <Table
            size="small"
            rowKey="id"
            dataSource={data}
            columns={columns}
            bordered
            className="table-container"
            pagination={false}
            style={{ margin: "1rem" }}
            onRow={(record) => ({
              onClick: (event) => {
                handleRowClick(record?.id);
              },
            })}
            scroll={{
              y: `${remainingViewportHeight(36)}px`,
              x: 1000,
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "1rem",
            }}
          >
            <Pagination
              size="small"
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              onChange={onPageChange}
              pageSizeOptions={["10", "15", "30", "50", "100"]}
              showQuickJumper
              current={currentPage}
              defaultPageSize={pageSize}
              total={itemsLength}
            />
          </div>
        </Spin>
      </div>
      <FilterTemplates
        applications={applications}
        roles={roles}
        types={types}
        setSelectedRoles={setSelectedRoles}
        setSelectedTypes={setSelectedTypes}
        setSelectedApplications={setSelectedApplications}
        selectedApplications={selectedApplications}
        selectedTypes={selectedTypes}
        selectedRoles={selectedRoles}
        visible={visible}
        ResetFields={ResetFields}
        handleApply={handleApply}
        handleCancel={handleCancel}
      />
    </CaSideNav>
  );
};

export default TemplateListing;
